module.exports = __webpack_public_path__ + "assets/251be804b4a932af30630c84b8b656fd.mp3";